module.exports = __webpack_public_path__ + "img/time.a330acc7.svg";